import { type FC } from "react";

import { Stack } from "@mantine/core";

import { useTopPerformerLenses } from "../../hooks";
import { postersThresholdOf } from "../../utils";

import { AwardHistoryCard } from "./AwardHistoryCard";
import { HowPayoutsWorkBand } from "./HowPayoutsWorkBand";
import { TopPerformerLensTable } from "./TopPerformerLensTable";
import { card, intro } from "./TopPerformerTab.module.css";
import { Intro } from "./messages.generated";

export const TopPerformerTab: FC = () => {
    const { lenses, enrolledCount, awardedCount, totalEarnedMilliUsd, loading, error } = useTopPerformerLenses();

    return (
        <Stack gap="lg" pt="lg">
            <p className={`paragraph-p300 ${intro}`}>
                <Intro />
            </p>
            <HowPayoutsWorkBand postersThreshold={postersThresholdOf(lenses)} />
            <section className={card}>
                <AwardHistoryCard lenses={lenses} loading={loading} hasError={Boolean(error)} />
            </section>
            <section className={card}>
                <TopPerformerLensTable
                    lenses={lenses}
                    enrolledCount={enrolledCount}
                    awardedCount={awardedCount}
                    totalEarnedMilliUsd={totalEarnedMilliUsd}
                    loading={loading}
                    hasError={Boolean(error)}
                />
            </section>
        </Stack>
    );
};
